var React = require('react');

function Keap (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"16","height":"16","rx":"8","fill":"#36A635","key":0}),React.createElement("path",{"d":"M11.1515 11.5257L10.3573 12.3483C10.2438 12.4901 10.0736 12.4617 9.93181 12.3483L7.12376 9.48351V12.1497C7.12376 12.3199 7.01031 12.4334 6.81176 12.4334H5.6772C5.50701 12.4334 5.39355 12.3199 5.39355 12.1497V3.83906C5.39355 3.66888 5.50701 3.55542 5.6772 3.55542H6.81176C7.01031 3.55542 7.12376 3.66888 7.12376 3.83906V6.56201H10.9529C11.1231 6.56201 11.2366 6.67547 11.2366 6.84565V8.00858C11.2366 8.17877 11.1231 8.29222 10.9529 8.29222H8.34342L11.1515 11.1286C11.2649 11.2421 11.2649 11.3839 11.1515 11.5257Z","fill":"white","key":1})]);
}

Keap.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Keap;

Keap.default = Keap;
